import { render } from "./SvgPlayerButtonPause.vue?vue&type=template&id=527b9f44&scoped=true"
import script from "./SvgPlayerButtonPause.vue?vue&type=script&lang=js"
export * from "./SvgPlayerButtonPause.vue?vue&type=script&lang=js"

import "./SvgPlayerButtonPause.vue?vue&type=style&index=0&id=527b9f44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527b9f44"]])

export default __exports__